import {
  beginningBalanceColumnDefinition,
  bookTypeColumnDefinition,
  costCenterColumnDefinition,
  currencyColumnDefinition,
  geographyColumnDefinition,
  importValidationColumnDefinition as importValidationColDef,
  localAccountColumnDefinition,
  localAccountDescriptionColumnDefinition,
  productLineColumnDefinition,
  projectColumnDefinition,
  r2RAccountColumnDefinition,
  r2RDescriptionColumnDefinition,
  referenceColumnDefinition,
  tradingPartnerColumnDefinition,
} from '../columnDefinitions';

export const beginningBalancesColumnDefsTpc = [
  { ...localAccountColumnDefinition, headerName: 'Local Account' },
  { ...localAccountDescriptionColumnDefinition, headerName: 'Local Description', width: 450 },
  r2RAccountColumnDefinition,
  r2RDescriptionColumnDefinition,
  { ...beginningBalanceColumnDefinition, field: 'ytdBalance' },
  { ...currencyColumnDefinition, field: 'currencyCode' },
  bookTypeColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  { ...projectColumnDefinition, field: 'project' },
  referenceColumnDefinition,
  productLineColumnDefinition,
];

export const beginningBalancesColumnDefsEsdrm = [
  r2RAccountColumnDefinition,
  r2RDescriptionColumnDefinition,
  { ...beginningBalanceColumnDefinition, field: 'ytdBalance' },
  { ...currencyColumnDefinition, field: 'currencyCode' },
  bookTypeColumnDefinition,
  tradingPartnerColumnDefinition,
  costCenterColumnDefinition,
  geographyColumnDefinition,
  { ...projectColumnDefinition, field: 'project' },
  referenceColumnDefinition,
  productLineColumnDefinition,
];

export const importValidationColumnDefinition = {
  ...importValidationColDef,
  field: 'importValidation',
};
